app.controller('videoController', ['$scope', '$rootScope', '$stateParams', '$timeout', 'objectHelper', 'applicationModel', 'authModel', 'visitModel',
    function ($scope, $rootScope, $stateParams, $timeout, objectHelper, applicationModel, authModel, visitModel) {

        var session;
        var subscriber;
        var publisher;

        function setData() {
            applicationModel.viewReady = true;
            $scope.waitingForDoctor = true;
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on(Event.VISIT.STREAMING_CONNECTION_DETAILS.SUCCESS, function (event, data) {
                $scope.streamingConnectionDetails = data;
                var apiKey = data.apiKey;
                var sessionId = data.sessionID;
                var token = data.token;
                session = OT.initSession(apiKey, sessionId);
                session.on({
                    streamCreated: function(event) {
                        console.log("stream created");
                        $scope.waitingForDoctor = false;
                        $scope.$apply();
                        subscriber = session.subscribe(event.stream, 'subscribersDiv', {insertMode: 'replace', width: 640, height: 480});
                    },
                    streamDestroyed: function () {
                        console.log("stream streamDestroyed");
                        $('#subscribersDivContainer').html('<div id="subscribersDiv"></div>');
                    }
                });
                session.connect(token, function(error) {
                    if (error) {
                        console.log(error.message);
                    } else {
                        publisher = session.publish('myPublisherDiv', {width: 140, height: 105});
                    }
                });
            });
        }

        function setActions() {

        }

        function configureInterface() {
        }

        function initialize() {
            visitModel.getStreamingConnectionDetails($stateParams.streamingSessionId)
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
